import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
    selector: "app-error-with-refresh",
    templateUrl: "./error-with-refresh.component.html",
    styleUrls: ["./error-with-refresh.component.scss"],
    standalone: false
})
export class ErrorWithRefreshComponent implements OnInit {
  @Input() error: string;
  @Output() refresh: EventEmitter<void> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  onRefreshClick(): void {
    this.refresh.emit();
  }
}
